// El puesto y el tipo de trabajo de un contratado, en cristiano (S10: los elige el agente en su plan).
import { t } from '../../../i18n';
import { puesto } from '../compartido/puestos';

/** «Programador/a», o «Puesto por decidir» mientras Pau no aprueba su plan. */
export function tituloPuesto(clave: string | undefined): string {
  return (clave && puesto(clave)?.titulo) || t('oficinaV2.puesto.porDecidir');
}

/** «Trabajará como Investigador/a · solo mira y te cuenta; no cambia nada». */
/**
 * Lo que Pau necesita saber del trabajo: si solo va a mirar o si va a cambiar cosas. El puesto («Investigación»,
 * «Programación»…) es para el agente, no para Pau (28-09: «lo técnico no me interesa»), y ya no se le enseña.
 */
export function lineaDelPuesto(_clave: string | undefined, tipo: string | undefined): string {
  return tipo === 'cambiar' ? t('oficinaV2.puesto.cambiar') : tipo === 'investigar' ? t('oficinaV2.puesto.investigar') : '';
}
